import {FC} from 'react'

import {VideoIframe} from '@/components/video/VideoIframe'
import {useVideoContent} from '@/content/video'
import {analytics} from '@/utils/tracking/analytics'

type BrandMonitoringIntroVideoProps = {
  sizes: string
  isPriority?: boolean
  trackedEventParameters?: Record<string, string>
}

export const BrandMonitoringIntroVideo: FC<BrandMonitoringIntroVideoProps> = ({
  sizes,
  isPriority,
  trackedEventParameters,
}) => {
  const {url, thumbnail} = useVideoContent().brandProtection

  return (
    <VideoIframe
      src={url}
      thumbnail={thumbnail}
      sizes={sizes}
      isPriority={isPriority}
      onClick={() => analytics.track('Brand protection video played', trackedEventParameters)}
    />
  )
}
